<template>
  <div class="matrixradio-chart">
    <el-row>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="选项">
          <template slot-scope="scope">{{ scope.row.text }}</template>
        </el-table-column>
        <el-table-column
          v-for="(opt, i) in answerSort"
          align="center"
          :label="'排序第' + (i + 1)"
          :key="i"
        >
          <template slot-scope="scope">{{ scope.row.answerOptions[i].count }}</template>
        </el-table-column>
        <el-table-column align="center" label="综合排名">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row v-if="showChart">
      <div class="type-selector">
        <el-radio-group v-model="chartType" @change="handleChangeType" size="medium">
          <el-radio-button label="柱状图"></el-radio-button>
          <el-radio-button label="条形图"></el-radio-button>
          <el-radio-button label="折线图"></el-radio-button>
        </el-radio-group>
      </div>
      <vue-highcharts v-show="chartType == '条形图'" :options="barOptions" ref="barCharts"></vue-highcharts>
      <vue-highcharts v-show="chartType == '柱状图'" :options="columnOptions" ref="columnCharts"></vue-highcharts>
      <vue-highcharts v-show="chartType == '折线图'" :options="lineOptions" ref="lineCharts"></vue-highcharts>
    </el-row>
  </div>
</template>

<script>
import VueHighcharts from "vue2-highcharts";
export default {
  name: "sortChart",
  props: ["quesInfo", "showChart"],
  components: {
    VueHighcharts
  },
  computed: {
    answerSort() {
      return this.quesInfo.groupMatrixList[0].answerOptions;
    },
    optArr() {
      return this.quesInfo.groupMatrixList.map(val => {
        return val.text;
      });
    },
    countArr() {
      return this.quesInfo.groupMatrixList.map((val, i) => {
        return this.quesInfo.groupMatrixList.length - i;
      });
    },
    barOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: this.optArr
        },
        yAxis: {
          title: {
            text: ""
          }
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        series: [{ name: "小计", data: this.countArr }]
      };
    },
    columnOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: this.optArr
        },
        yAxis: {
          title: {
            text: ""
          }
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        series: [{ name: "小计", data: this.countArr }]
      };
    },
    lineOptions() {
      return {
        chart: {
          type: "line"
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: this.optArr
        },
        yAxis: {
          title: {
            text: ""
          }
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        series: [{ name: "小计", data: this.countArr }]
      };
    },
    tableData() {
      return this.quesInfo.groupMatrixList;
    }
  },
  data() {
    return {
      loaded: false,
      chartType: "条形图",
      typeMap: { 柱状图: "column", 条形图: "bar", 折线图: "line" }
    };
  },
  mounted() {
    this.loaded = true;
  },
  methods: {
    handleChangeType(val) {
      let _chart = this.$refs[this.typeMap[val] + "Charts"];
      _chart.removeSeries();
      _chart.addSeries({ name: "小计", data: this.countArr });
    }
  }
};
</script>

<style lang="scss">
.matrixradio-chart {
  .type-selector {
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/singleAnalysis/sortChart.vue